<script>
  export let label = "";
  export let groupName = "";
  export let value = "";
  export let required = false;
  export let options = [];

  export let onChange = null;
  let inputID = Math.random().toString(36).slice(2, 12);

  function handleChange(e) {
      if (typeof onChange === 'function') {
          onChange(e.target.value);
      }
  }
</script>

{#if label}
  <label class="form-label" for={inputID}>
      {label}
      {#if required}
          <span class="text-red">*</span>
      {/if}
  </label>
{/if}
{#each options as option }
  <div class="form-check">
    <input 
    class="form-check-input"
          type="radio"
          id={groupName + option.label}
          name={groupName}
          value={option.value}
          checked={value == option.value}
          on:change={handleChange}
      >
    <label class="form-check-label" for={groupName + option.label}>
      {option.label}
    </label>
  </div>
{/each}
